export default "__VITE_ASSET__BVOWb8Mr__"